/* eslint-disable no-use-before-define */

import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import React from "react";

export default function LocationSelect(props) {
  const onChange = props.onChange || (() => {});
  const theError = props.error;
  const options = props.options;
  const value = props.value;
  const helper = props.helperText;
  /* eslint-disable */

  const label = props.label;
  //console.log("theError: ", theError);
  //console.log("helper: ", helper);

  /*
  const options = kommuner.map(function (kommun) {
    return kommun.name;
  });*/

  if (true === true) {
    return (
      <Autocomplete
        variant="outlined"
        required
        disablePortal
        onChange={(event, newValue) => {
          onChange(newValue);
        }}
        id="combo-box-demo"
        options={options}
        sx={{ minWidth: 280 }}
        renderInput={(params) => <TextField {...params} label={label} />}
        value={value}
      />
    );
  }
  return (
    <Autocomplete
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      style={{ minWidth: 280 }}
      options={options}
      style={{ fontSize: 15 }}
      autoHighlight
      getOptionLabel={(option) => {
        return option;
      }}
      renderOption={(option) => <React.Fragment>{option}</React.Fragment>}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required
          variant="outlined"
          error={theError}
          helperText={helper}
          inputProps={{
            ...params.inputProps,
            autoComplete: "off", // disable autocomplete and autofill
          }}
        />
      )}
    />
  );
}

//code, label
